// 导入所有模块的翻译
import { common as commonEn } from './modules/common/en';
import { dashboard as dashboardEn } from './modules/dashboard/en';
import { login as loginEn } from './modules/auth/login/en';
import { navbar as navbarEn } from './modules/auth/navbar/en';
import { workings as workingsEn } from './modules/working/en';
import { file as fileEn, fileAuthShareModal as fileAuthShareModalEn } from './modules/file/en';
import { course as courseEn } from './modules/course/en';
import { homework as homeworkEn } from './modules/homework/en';
import { teacherClass as teacherClassEn } from './modules/teacherClass/en';
import { student as studentEn } from './modules/student/en';
import {
    adminManager as adminManagerEn,
    registerCoder as registerCoderEn,
    timesheetList as timesheetListEn,
    groupManager as groupManagerEn,
    managerLocation as managerLocationEn,
    TeachingSubjectManager as TeachingSubjectManagerEn,
    UsersManager as UsersManagerEn,
    studentManager as studentManagerEn,
    classManager as classManagerEn,
} from './modules/admin/en';

import { common as commonZh } from './modules/common/zh';
import { dashboard as dashboardZh } from './modules/dashboard/zh';
import { login as loginZh } from './modules/auth/login/zh';
import { navbar as navbarZh } from './modules/auth/navbar/zh';
import { workings as workingsZh } from './modules/working/zh';
import { file as fileZh, fileAuthShareModal as fileAuthShareModalZh } from './modules/file/zh';
import { course as courseZh } from './modules/course/zh';
import { homework as homeworkZh } from './modules/homework/zh';
import { teacherClass as teacherClassZh } from './modules/teacherClass/zh';
import { student as studentZh } from './modules/student/zh';
import {
    adminManager as adminManagerZh,
    registerCoder as registerCoderZh,
    timesheetList as timesheetListZh,
    groupManager as groupManagerZh,
    managerLocation as managerLocationZh,
    TeachingSubjectManager as TeachingSubjectManagerZh,
    UsersManager as UsersManagerZh,
    studentManager as studentManagerZh,
    classManager as classManagerZh,
} from './modules/admin/zh';

import enUS from "antd/es/locale/en_US";
import zhCN from "antd/es/locale/zh_CN";
import { Locale } from "antd/es/locale";

// 合并所有英文翻译
const en = {
    ...commonEn,
    ...dashboardEn,
    ...loginEn,
    ...navbarEn,
    ...workingsEn,
    ...fileEn,
    ...fileAuthShareModalEn,
    ...courseEn,
    ...homeworkEn,
    ...teacherClassEn,
    ...studentEn,
    ...adminManagerEn,
    ...registerCoderEn,
    ...timesheetListEn,
    ...groupManagerEn,
    ...managerLocationEn,
    ...TeachingSubjectManagerEn,
    ...UsersManagerEn,
    ...studentManagerEn,
    ...classManagerEn,
};

// 合并所有中文翻译
const zh = {
    ...commonZh,
    ...dashboardZh,
    ...loginZh,
    ...navbarZh,
    ...workingsZh,
    ...fileZh,
    ...fileAuthShareModalZh,
    ...courseZh,
    ...homeworkZh,
    ...teacherClassZh,
    ...studentZh,
    ...adminManagerZh,
    ...registerCoderZh,
    ...timesheetListZh,
    ...groupManagerZh,
    ...managerLocationZh,
    ...TeachingSubjectManagerZh,
    ...UsersManagerZh,
    ...studentManagerZh,
    ...classManagerZh,
};

interface LocalesMap {
    [key: string]: Record<string, string>;
}

const messages: LocalesMap = {
    en,
    zh,
};

// localStorage key
const STORAGE_KEY = 'app_locale';

// 初始化当前语言
let current = 'en';

// 尝试从 localStorage 读取
const storedLocale = localStorage.getItem(STORAGE_KEY);
if (storedLocale && (storedLocale === 'en' || storedLocale === 'zh')) {
    current = storedLocale;
} else {
    const navLang = typeof navigator !== 'undefined' ? navigator.language.toLowerCase() : 'en';
    current = navLang.startsWith('zh') ? 'zh' : 'en';
    localStorage.setItem(STORAGE_KEY, current);
}

// 获取当前语言
export function getCurrentLocale() {
    return current;
}

export function getAntdLocale(): Locale | undefined {
    const locale = getCurrentLocale(); // 'en' | 'zh'

    switch (locale) {
        case 'zh':
            return zhCN;
        case 'en':
        default:
            return enUS;
    }
}

// 设置全局语言，同时写入 localStorage
export function setLocale(locale: string) {
    if (messages[locale]) {
        current = locale;
        localStorage.setItem(STORAGE_KEY, locale);
    }
}

// 类型定义（可选，用于 TypeScript）
interface TranslationParams {
    [key: string]: string | number | boolean | undefined
}

// 根据 code 获取翻译，并支持参数替换
export function t(code: string, params?: TranslationParams): string {
    // 尝试当前语言
    let msg = messages[current]?.[code];
    if (msg === undefined || msg === null) {
        // 回退到英文
        msg = messages['en']?.[code];
    }
    if (msg === undefined || msg === null) {
        // 实在找不到，返回 code 本身
        msg = code;
    }

    // 如果有参数，执行模板替换（支持 {{key}} 格式）
    if (params) {
        return msg.replace(/\{\{(\w+)}}/g, (match, key) => {
            const value = params[key];
            return value !== undefined ? String(value) : match;
        });
    }

    return msg;
}

// 导出合并后的翻译对象（用于向后兼容）
export { en, zh };
